module.exports = __webpack_public_path__ + "dashboard-22.568e2a45f8011d533996.png";


//////////////////
// WEBPACK FOOTER
// /home/federicblack/public_html/GrupoCristalino/src/assets/img/dashboard-22.png
// module id = ../../../../../src/assets/img/dashboard-22.png
// module chunks = main